import React, { useEffect, useState } from "react";
import { useMessageApi } from "../../../provider/AntdNotification";
import { useQueryState } from "nuqs";
import { Form } from "antd";
import { getSingleImageUrl } from "../../../lib/utils";
import TabsContain from "../../components/reuseComp/TabsContain";

import HomeBanner from "./HomeBanner";
// import FilingMilestone from "./FilingMilestone";
// import AboutTax from "./AboutTax";
// import HowItWorks from "./HowItWorks";
// import GetApp from "./GetApp";
// import Testimonials from "./Testimonials";
import {
  useAllPageDetail,
  useAllPageSave,
} from "../../../hooks/api/allPages/hooks";

import { PageType, IPagePayload } from "../../../types/api/allPages";
import FilingMilestone from "./FilingMilestone";
import AboutTax from "./AboutTax";
import GetApp from "./GetApp";
import HowItWorks from "./HowItWorks";
import Testimonials from "./Testimonials";

const HomeTabsSection: React.FC<{ setBreadcrumb: (value: string) => void }> = ({
  setBreadcrumb,
}) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const [form] = Form.useForm();

  const activeTab = tab || "Banner";

  const pageType: PageType = "PRELOGIN";


  const [isEditing, setIsEditing] = useState(false);
  const [pageData, setPageData] = useState<any>(null);

const { data } = useAllPageDetail(pageType);
const { mutate: savePage, isPending } = useAllPageSave(pageType, {
  onSuccess: (res) => {
    message.success("Home data updated successfully");
    setPageData(res.data?.data || {});
    setIsEditing(false);
    setReviewMode("list");
    setEditingReviewIndex(null);
  },
  onError: () => message.error("Failed to update page"),
});

  const [reviewMode, setReviewMode] = useState<"list" | "add" | "edit">("list");
  const [editingReviewIndex, setEditingReviewIndex] = useState<number | null>( null );

useEffect(() => {
  if (data?.data) {
    setPageData(data.data.data); // ✅ IMPORTANT
  }
}, [data]);

  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setReviewMode("list");
    setBreadcrumb(section);
    setEditingReviewIndex(null);

  };

 const handleSave = async () => {
  try {
    const values = await form.validateFields();

    const updatedData = { ...pageData };


    // Testimonials
    if (activeTab === "Testimonials") {
      const users = [...(pageData?.testimonials?.users || [])];

      if (reviewMode === "add") {
        users.push(values.review);
      }

      if (reviewMode === "edit" && editingReviewIndex !== null) {
        users[editingReviewIndex] = values.review;
      }

      updatedData.testimonials = {
        heading:
          values.testimonials?.heading ?? pageData?.testimonials?.heading,
        description:
          values.testimonials?.description ??
          pageData?.testimonials?.description,
        users,
      };
    }

    const payload: any = {
        _id: data?.data?._id,
        ...updatedData ,
        ...values
      };



    savePage(payload);
  } catch (error) {
  }
};

  const handleCancel = () => {
    setIsEditing(false);
          setReviewMode("list");
    setEditingReviewIndex(null);


  };

  const handleReviewDelete = (index: number) => {
  const updatedUsers = [...(pageData?.testimonials?.users || [])];
  updatedUsers.splice(index, 1);

  const updatedData = {
    ...pageData,
    testimonials: {
      ...pageData?.testimonials,
      users: updatedUsers,
    },
  };

  const payload: IPagePayload = {
    _id: data?.data?._id,
    pageType,
    data: updatedData,
  };

  savePage(payload);
};

  const sections = [
    "Banner",
    "Filing Milestones",
    "About Tax",
    "How It Works",
    "Get The App",
    "Testimonials",
  ];

  return (
    <div>
      <TabsContain
        handleChangeTab={handleChangeTab}
        sections={sections}
        activeTab={activeTab}
      />

      {activeTab === "Banner" && (
        <HomeBanner
          handleCancel={handleCancel}
          handleSave={handleSave}
          bannerData={pageData?.banner || {}}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          loading={isPending}
        />
      )}
      
      {activeTab === "Filing Milestones" && (
        <FilingMilestone
          handleCancel={handleCancel}
          handleSave={handleSave}
          milestoneData={pageData?.milestone || {}}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          loading={isPending}
        />
      )}

      {activeTab === "About Tax" && (
        <AboutTax
          handleCancel={handleCancel}
          handleSave={handleSave}
          aboutTaxData={pageData?.aboutTax || {}}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          loading={isPending}
        />
      )}

      {activeTab === "How It Works" && (
        <HowItWorks
          handleCancel={handleCancel}
          handleSave={handleSave}
          howItWorksData={pageData?.howItWorks || {}}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          loading={isPending}
        />
      )}

      {activeTab === "Get The App" && (
        <GetApp
          handleCancel={handleCancel}
          handleSave={handleSave}
          getAppData={pageData?.getApp || {}}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          loading={isPending}
        />
      )}

      {/* {activeTab === "Testimonials" && (
        <Testimonials
          handleCancel={handleCancel}
          handleSave={handleSave}
          testimonialsData={pageData?.testimonials || {}}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          loading={isPending}
        />
      )} */}

       {activeTab === "Testimonials" && (
        <Testimonials
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          testimonialsData={pageData?.testimonials}
          loading={isPending}
          reviewMode={reviewMode}
          setReviewMode={setReviewMode}
          editingReviewIndex={editingReviewIndex}
          setEditingReviewIndex={setEditingReviewIndex}
          onDeleteReview={handleReviewDelete}
        />
      )}
    </div>
  );
};

export default HomeTabsSection;